import { get } from "./base";

export function getmain(username) {
    return get('getmain.php', {
        username: username
    })
}

export function getTacticList() {
    return get('get_tactic_list.php');
}

export function getTactic(current) {
    return get('get_tactic.php', {
        tactic_current: current
    });
}

export function getQuicksay(current) {
    return get('get_quicksay.php', {
        tactic_current: current
    });
}
